<script setup lang="ts"></script>

<template>
  <button class="bg-yellow-600 rounded p-3 font-semibold transition-all disabled:opacity-70" v-bind="$attrs">
    <slot />
  </button>
</template>

<style scoped lang="scss"></style>
